// Miscellaneous utility functions for forms.

import { AbstractControl } from "@angular/forms";

/**
 * Function that determines if the hint icon should be hidden.
 * (per the design guidelines, it shouldn't be shown unless an error is present).
 *
 * @param control An abstract control.
 */
export function shouldHideHintIcon(control: AbstractControl) {
    return (
        // if there aren't any errors
        control.errors === null ||
        // if the control hasn't had it's value changed by the user (they touched it but didn't change its value)
        !control.dirty || 
        // if the control hasn't been touched and is currently invalid (i.e. the default state)
        !control.touched && control.invalid
    );
}